import {
  AdCallbacksExtended,
  AdCallbacksExtendedFactory,
  EmbedCodeBase,
} from '@shared/Ads/Yandex/types';

import {bindClickLogger} from '@shared/Ads/Yandex/utils/bindClickLogger';

type Params = {
  containerId: string;
  code: EmbedCodeBase;
  factories: Array<AdCallbacksExtendedFactory>;
  callback?: AdCallbacksExtended;
};

export const combineAndExtendCallbacks = ({
  containerId,
  code,
  factories,
  callback = {},
}: Params): {callbacks: Required<AdFox.AdCallbacks>; cleanup: VoidFunction} => {
  const cleanupCallbacks: Array<VoidFunction> = [];

  const callbacks = [
    ...factories.map((f) => f({containerId, code, cleanupCallbacks})),
    callback,
  ];

  const prepareClickLogging = (data: AdFox.RenderData) => {
    const element = data.stickyAdNode || document.getElementById(containerId);
    if (element) {
      cleanupCallbacks.push(
        bindClickLogger(element, () => {
          callbacks.forEach(({onClick}) => onClick?.());
        }),
      );
    }
  };

  return {
    callbacks: {
      onClose: () => {
        callbacks.forEach(({onClose}) => onClose?.());
      },
      onError: (data) => {
        callbacks.forEach(({onError}) => onError?.(data));
      },
      onLoad: (data) => {
        callbacks.forEach(({onLoad}) => onLoad?.(data));
      },
      onRender: (data) => {
        prepareClickLogging(data);
        callbacks.forEach(({onRender}) => onRender?.(data));
      },
      onStub: () => {
        callbacks.forEach(({onStub}) => onStub?.());
      },
    },
    cleanup: () => {
      cleanupCallbacks.forEach((cb) => cb());
    },
  };
};
